<header class="header header--desktop hidden border-b border-black-100 sticky top-0 left-0 z-50 bg-white lg:block">
  <div class="main-container flex items-center justify-between h-14">
    <a routerLink="/" class="flex header__logo bg-purple-600 h-full w-35 items-center justify-center px-4">
      <img class="block w-full h-auto" ngSrc="/images/header/public-logo.svg" width="597" height="128" priority alt="Match15 Logo">
    </a>
    <nav class="header__nav flex h-full">
      <a
        routerLink="/games"
        routerLinkActive="text-purple-600 bg-purple-100"
        class="header__link text-gray-100 hover:bg-purple-100"
      >
        Play games
      </a>
      <a
        routerLink="/cards"
        routerLinkActive="text-purple-600 bg-purple-100"
        class="header__link text-gray-100 hover:bg-purple-100"
      >
        My cards
      </a>
      <a
        routerLink="/account"
        routerLinkActive="text-purple-600 bg-purple-100"
        class="header__link text-gray-100 hover:bg-purple-100"
      >
        My account
      </a>
      <a
        routerLink="/settings"
        routerLinkActive="text-purple-600 bg-purple-100"
        class="header__link text-gray-100 hover:bg-purple-100"
      >
        Help
      </a>
    </nav>
    <div class="header__balance">
      <bingo-balance />
    </div>
  </div>
</header>

<header class="header header--mobile block pt-2 border-t border-black-100 lg:hidden">
  <nav class="header__nav flex justify-center w-full text-center">
    <a
      routerLink="/games"
      routerLinkActive="text-purple-600"
      class="header__link text-gray-100 flex items-center gap-x-2 flex-col"
    >
      <mat-icon aria-hidden="false" fontIcon="star" />
      Play games
    </a>
    <a
      routerLink="/cards"
      routerLinkActive="text-purple-600"
      class="header__link text-gray-100 flex items-center gap-x-2 flex-col"
    >
      <mat-icon [class.flash_me]="gameNotification.needFlash()" aria-hidden="false" fontIcon="cards" fontSet="material-symbols-outlined">cards</mat-icon>
      My cards
    </a>
    <a
      routerLink="/account"
      routerLinkActive="text-purple-600"
      class="header__link text-gray-100 flex items-center gap-x-2 flex-col"
    >
      <mat-icon aria-hidden="false" fontIcon="person" />
      My account
    </a>
    <a
      routerLink="/settings"
      routerLinkActive="text-purple-600"
      class="header__link text-gray-100 flex items-center gap-x-2 flex-col"
    >
      <mat-icon aria-hidden="false" fontIcon="help" />
      Help
    </a>
  </nav>
</header>
